import { getSearchUiState } from '@/redux/modules/search/search.selectors';
import {
    PromotionalBanner,
    PromotionalBannerVariant,
} from '@liveauctioneers/hammer-ui-liveauctioneers/promotionalBanner';
import { useAppSelector } from '@/redux/hooks';
import { useGetFormattedSearchResultsText } from '../../hooks/useGetFormattedSearchResultsText';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { useMemo } from 'react';

type Props = {
    isArchivedSearchPage: boolean;
};

export const MarketingEventBanner = ({ isArchivedSearchPage }: Props) => {
    const { totalFound } = useAppSelector(getSearchUiState);
    const { formatMessage } = useIntl();
    const totalFoundRounded = useGetFormattedSearchResultsText({ totalFound });

    const bottomText = useMemo(() => {
        if (isArchivedSearchPage) {
            return formatMessage(
                { id: 'searchPage.promotedEvent.bottomTextPriceResults' },
                {
                    totalFoundRounded,
                }
            );
        }

        return formatMessage(
            { id: 'searchPage.promotedEvent.bottomTextUpcomingAuctions' },
            {
                totalFoundRounded,
            }
        );
    }, [isArchivedSearchPage, totalFoundRounded, formatMessage]);

    return (
        <PromotionalBanner
            bottomText={bottomText}
            description={formatMessage({ id: 'searchPage.promotedEvent.description' })}
            title={formatMessage({ id: 'searchPage.promotedEvent.title' })}
            variant={PromotionalBannerVariant.STAR_WARS}
        />
    );
};
